<template>
  <div
    class="flex bg-primary min-h-screen h-full w-screen flex-col sm:flex-row sm:justify-center"
  >
    <div class="w-full sm:w-[32rem] my-auto py-4 px-1">
      <slot />
    </div>
  </div>
</template>
